export default "ee7c413316cbdc73.svg"